import React from 'react'

import { TemplatesPDF } from '@interco/cp-react-ui-lib'

const CartilhaCreditoTrabalhador = () => <TemplatesPDF.PageCartilhaCreditoTrabalhador />

export default CartilhaCreditoTrabalhador
